// this function filters out objects from the first array that contain IDs present in the second array
export const filterOutMatchingObjects = (array1, array2) => {
    const array2Ids = array2.map((obj) => obj.id);
    return array1.filter((obj) => !array2Ids.includes(obj.id));
};
